export * from './auth.guard';



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Guards/index.ts